<template>
  <base-section id="procedure">
    <v-container class="procedure-shell">
      <div class="procedure-page">
        <!-- <div class="procedure-header">
          <base-img
            :src="require('@/assets/new-logo.png')"
            contain
            max-width="220"
          />
        </div> -->

        <section
          v-for="section in procedures"
          :key="section.id"
          class="procedure-section"
          :class="`procedure-section--${section.id}`"
        >
          <div class="procedure-left">
            <div class="procedure-title-wrap">
              <div class="procedure-title">
                {{ section.title }}
              </div>
              <div class="procedure-title-shadow"></div>
            </div>

            <p class="procedure-desc">
              {{ section.description }}
            </p>

            <ol class="procedure-steps">
              <li
                v-for="(step, index) in section.steps"
                :key="`${section.id}-${index}`"
              >
                {{ step }}
              </li>
            </ol>
          </div>

          <div class="procedure-diagram">
            <base-img
              class="procedure-image"
              :src="section.image"
              :alt="section.title"
              contain
            />
          </div>
        </section>
      </div>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionProcedure",

  provide: {
    heading: { align: "center" }
  },

  data: () => ({
    procedures: [
      {
        id: "pendaftaran",
        image: require("@/assets/procedure_register.png"),
        title: "Prosedur Pendaftaran",
        description:
          "Pendaftaran asuransi mudah dan cepat, hanya dengan menghubungi Customer Solution PT Asuransi Takaful Umum melalui WhatsApp +62 811-1906-1995 dengan cara sebagai berikut:",
        steps: [
          "Menghubungi Customer Solution PT Asuransi Takaful Umum.",
          "Mengisi Formulir penutupan asuransi syariah (SPAUS).",
          "Melengkapi berkas yang dibutuhkan.",
          "E-polis dikirimkan oleh PT Asuransi Takaful Umum melalui email peserta.",
          "Peserta dapat mentransfer biaya kontribusi atas nama PT Asuransi Takaful Umum pada bank yang telah ditentukan.",
          "Asuransi sudah aktif untuk waktu yang ditentukan."
        ]
      },
      {
        id: "klaim",
        image: require("@/assets/procedure_klaim.png"),
        title: "Prosedur Klaim",
        description:
          "Takaful Umum menerapkan truesight claim yang memudahkan peserta melakukan klaim digital secara online tanpa harus datang ke kantor, cukup menghubungi Customer Solution kami melalui WhatsApp +62 811-1906-1995 dengan cara sebagai berikut:",
        steps: [
          "Menghubungi Customer Solution PT Asuransi Takaful Umum.",
          "Mengisi Formulir klaim.",
          "Melengkapi berkas klaim yang dibutuhkan.",
          "Pihak Takaful Umum melakukan survey klaim (Offline dan atau online)",
          "Keluar SPK (Surat Perintah Kerja) dan klaim diterima.",
          "Takaful Umum membayar biaya klaim dengan jumlah yang sudah ditentukan."
        ]
      }
    ]
  })
};
</script>

<style scoped>
.procedure-shell {
  padding-top: 10px;
  padding-bottom: 28px;
}

.procedure-page {
  overflow: hidden;
  padding: 22px 28px 34px;
  background: #fff;
  box-shadow: 0 14px 36px rgba(6, 30, 61, 0.08);
}

.procedure-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
}

.procedure-section {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(250px, 0.9fr);
  align-items: start;
  gap: 20px 26px;
  margin-top: 8px;
}

.procedure-section + .procedure-section {
  margin-top: 56px;
}

.procedure-left {
  min-width: 0;
}

.procedure-title-wrap {
  width: 100%;
  max-width: 460px;
  margin: 4px 0 18px;
}

.procedure-title {
  position: relative;
  overflow: hidden;
  padding: 16px 24px 16px 56px;
  border-radius: 0 14px 14px 0;
  background: linear-gradient(90deg, #42bfd0, #53cad8);
  color: #fff;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.procedure-title::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 48px;
  opacity: 0.22;
  background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.8),
        rgba(255, 255, 255, 0)
      )
      8px 0/2px 100% no-repeat,
    linear-gradient(180deg, rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0))
      15px 0/2px 100% no-repeat,
    linear-gradient(180deg, rgba(255, 255, 255, 0.65), rgba(255, 255, 255, 0))
      22px 0/2px 100% no-repeat,
    linear-gradient(180deg, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0))
      29px 0/2px 100% no-repeat;
}

.procedure-title-shadow {
  width: 168px;
  height: 10px;
  margin-left: 2px;
  border-radius: 0 0 3px 3px;
  background: #0b3b74;
}

.procedure-desc {
  max-width: 600px;
  margin: 0 0 14px;
  padding-left: 30px;
  color: #2a2d34;
  font-size: 15px;
  line-height: 1.95;
  text-align: justify;
}

.procedure-steps {
  margin: 0;
  padding-left: 56px;
}

.procedure-steps li {
  margin-bottom: 4px;
  padding-left: 10px;
  color: #20232a;
  font-size: 15px;
  line-height: 1.82;
}

.procedure-steps li::marker {
  font-weight: 700;
}

.procedure-diagram {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: 100%;
  padding: 56px 8px 0 0;
}

.procedure-image {
  width: 100%;
  max-width: 320px;
  max-height: 360px;
}

@media (max-width: 960px) {
  .procedure-page {
    padding: 22px 18px 30px;
  }

  .procedure-title-wrap {
    max-width: none;
  }

  .procedure-section {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .procedure-section + .procedure-section {
    margin-top: 38px;
  }

  .procedure-desc {
    max-width: none;
    padding-left: 18px;
  }

  .procedure-steps {
    padding-left: 40px;
  }

  .procedure-diagram {
    padding-right: 0;
    padding-top: 8px;
  }
}

@media (max-width: 600px) {
  .procedure-page {
    padding: 18px 14px 24px;
  }

  .procedure-header {
    justify-content: center;
    margin-bottom: 12px;
  }

  .procedure-title {
    padding: 13px 18px 13px 46px;
    font-size: 18px;
  }

  .procedure-title-shadow {
    width: 126px;
    height: 8px;
  }

  .procedure-desc,
  .procedure-steps li {
    font-size: 14px;
    line-height: 1.75;
  }

  .procedure-desc {
    padding-left: 8px;
  }

  .procedure-steps {
    padding-left: 28px;
  }

  .procedure-diagram {
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0 auto;
  }

  .procedure-image {
    display: block;
    max-width: 270px;
    margin: 0 auto;
  }
}

.procedure-section--klaim .procedure-image {
  max-width: 300px;
}

.procedure-section--klaim .procedure-diagram {
  padding-top: 92px;
  margin-top: 0;
}

@media (max-width: 600px) {
  .procedure-section--klaim .procedure-diagram {
    padding-top: 0;
    margin-top: 0;
  }
}
</style>
